var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"player-section"}},[_c('video',{key:_vm.videoMp4,attrs:{"id":"wipo-player","controls":"","poster":_vm.thumbnail}},[_c('source',{attrs:{"type":"video/webm","src":_vm.videoWebM}}),_vm._v(" "),_c('source',{attrs:{"type":"video/mp4","src":_vm.videoMp4}}),_vm._v("\n      Your browser does not support the video tag.\n   ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55e0345c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Player.vue
// module id = 47
// module chunks = 0